import React, { useEffect } from 'react';
import { cx } from './_cx';

/**
 * Modal (UI primitive)
 *
 * Standardizes the modal overlay + surface + header typography so feature pages
 * don't each reinvent modal styles and drift over time.
 */
export function Modal({
  open,
  onClose,
  title,
  subtitle,
  children,
  className,
  style,
  'aria-label': ariaLabel,
}) {
  // Escape closes the modal (best-effort accessibility).
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="pv-modal-overlay"
      onClick={() => onClose?.()}
      role="dialog"
      aria-modal="true"
      aria-label={ariaLabel || (typeof title === 'string' ? title : undefined)}
    >
      <div
        className={cx('pv-modal', className)}
        style={style}
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" onClick={() => onClose?.()} className="pv-modal-close" aria-label="Close">
          ×
        </button>
        {(title || subtitle) ? (
          <div className="pv-modal-header">
            {title ? <div className="pv-modal-title">{title}</div> : null}
            {subtitle ? <div className="pv-modal-subtitle">{subtitle}</div> : null}
          </div>
        ) : null}
        {children}
      </div>
    </div>
  );
}

